/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNoMedicationAllergies = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m23 21.614.014-.014.693.693-1.414 1.414-3.965-3.965a9.957 9.957 0 0 1-6.857 2.243A3.98 3.98 0 0 0 12 20c1.849 0 3.549-.63 4.903-1.683l-3-3c-.266.22-.571.39-.903.508V17h-2v-1.175a2.991 2.991 0 0 1-.904-.508l-.873.873a3.946 3.946 0 0 0-.146-.043l-1.32-1.319 1.29-1.29A3.018 3.018 0 0 1 9 13H7v-2h2c0-.184.016-.363.048-.538L5.682 7.096A7.963 7.963 0 0 0 4 12a7.96 7.96 0 0 0 1.073 4H4c-.38 0-.748.053-1.097.152A9.96 9.96 0 0 1 2 12a9.96 9.96 0 0 1 2.257-6.33L.293 1.708l1.4-1.4zM11 13a1 1 0 0 0 1.468.882L11 12.414z" />
        <path d="M8 17a3 3 0 1 1 0 6H4a3 3 0 1 1 0-6zm-2 4h2a1 1 0 1 0 0-2H6zm6-19c5.523 0 10 4.477 10 10a9.95 9.95 0 0 1-1.144 4.643l-1.5-1.501A8 8 0 0 0 8.857 4.644L7.354 3.142A9.958 9.958 0 0 1 12 2z" />
        <path d="M17 12.786 15.214 11H17zm-4-4.612c.332.117.637.289.903.508l.925-.924 1.414 1.414-1.29 1.29c.018.103.03.207.037.313L11.214 7H13z" />
      </g>
    </g>
  </Icon>
);
export { SvgNoMedicationAllergies as NoMedicationAllergies };
